import { useState } from 'react'

type Props = {
  referralUrl: string
  referralCode: string
}

export default function ReferralLinkCard({ referralUrl, referralCode }: Props) {
  const [copyLabel, setCopyLabel] = useState('Copy Referral Link')

  async function onCopy() {
    try {
      await navigator.clipboard.writeText(referralUrl)
      setCopyLabel('Referral link copied')
      setTimeout(() => setCopyLabel('Copy Referral Link'), 1400)
    } catch {
      setCopyLabel('Copy failed')
      setTimeout(() => setCopyLabel('Copy Referral Link'), 1400)
    }
  }

  async function onShare() {
    try {
      if ((navigator as any).share) {
        await (navigator as any).share({ title: 'Join Pixeloop', url: referralUrl })
        return
      }
      await navigator.clipboard.writeText(referralUrl)
      setCopyLabel('Referral link copied')
      setTimeout(() => setCopyLabel('Copy Referral Link'), 1400)
    } catch {
      // no-op
    }
  }

  return (
    <div className="rounded-2xl border border-white/10 bg-[radial-gradient(950px_300px_at_0%_0%,rgba(59,130,246,0.22),transparent_55%),radial-gradient(950px_300px_at_100%_0%,rgba(14,116,144,0.16),transparent_55%)] p-5">
      <h1 className="text-2xl font-extrabold">Become a Pixeloop Ambassador</h1>
      <p className="mt-2 text-sm text-white/75">Invite creators, pros, and friends. Earn a share of Pixeloop protocol fees from their activity.</p>
      <ul className="mt-4 space-y-1.5 text-sm text-white/85">
        <li>* Recurring earnings from real activity</li>
        <li>* Tiered rewards as your reputation grows</li>
        <li>* Transparent, ledger-based payouts</li>
      </ul>
      <div className="mt-4 flex flex-wrap items-center gap-2">
        <button type="button" onClick={onCopy} className="rounded-full bg-brand px-4 py-2 text-sm font-semibold text-black hover:brightness-110">
          {copyLabel}
        </button>
        <button type="button" onClick={onShare} className="rounded-full border border-white/20 bg-white/5 px-4 py-2 text-sm font-semibold text-white hover:bg-white/10">
          Share
        </button>
      </div>
      <div className="mt-2 text-xs text-white/60">Your link tracks referrals automatically.</div>
      <div className="mt-3 rounded-xl border border-white/10 bg-black/30 p-3 text-sm">
        <div className="text-white/60">Referral code</div>
        <div className="font-semibold">{referralCode}</div>
        <div className="mt-1 break-all text-xs text-white/70">{referralUrl}</div>
      </div>
      <div className="md:hidden sticky bottom-2 mt-4 flex gap-2 rounded-xl border border-white/15 bg-black/70 p-2 backdrop-blur">
        <button type="button" onClick={onCopy} className="flex-1 rounded-full bg-brand px-3 py-2 text-xs font-semibold text-black">
          Copy link
        </button>
        <button type="button" onClick={onShare} className="flex-1 rounded-full border border-white/20 bg-white/10 px-3 py-2 text-xs font-semibold text-white">
          Share
        </button>
      </div>
    </div>
  )
}
